// extracted by mini-css-extract-plugin
module.exports = {"Item":"Item_Item__24lk-","wrapper":"Item_wrapper__3UiY2","textWrapper":"Item_textWrapper__3-Gqm","text":"Item_text__23v8V","image":"Item_image__2EBJf"};